import { render, staticRenderFns } from "./basebankaccount.vue?vue&type=template&id=f63bf0ec&scoped=true&"
import script from "./basebankaccount.vue?vue&type=script&lang=js&"
export * from "./basebankaccount.vue?vue&type=script&lang=js&"
import style0 from "./basebankaccount.vue?vue&type=style&index=0&id=f63bf0ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63bf0ec",
  null
  
)

export default component.exports